import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/inventory")({
  head: () => pageHead({ title: 'RV Inventory', description: 'Browse new and used RVs for sale at Rex & Sons RVs near Wilmington, NC.', path: '/inventory' }),
  beforeLoad: () => {
    throw redirect({ href: "/rv-search" });
  },
});
